/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Transcript_Export_Include_SpeakersInputs */

const en_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Include Speakers`)
};

const fr_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inclure les intervenants`)
};

const de_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sprecher einbeziehen`)
};

const it_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Includi altoparlanti`)
};

const ru_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить докладчиков`)
};

const es_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir oradores`)
};

const zh_cn2_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`包括演讲者`)
};

const ja_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スピーカーを含める`)
};

const hi_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वक्ताओं को शामिल करें`)
};

const pt_pt2_transcript_export_include_speakers = /** @type {(inputs: Transcript_Export_Include_SpeakersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incluir palestrantes`)
};

/**
* | output |
* | --- |
* | "Include Speakers" |
*
* @param {Transcript_Export_Include_SpeakersInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const transcript_export_include_speakers = /** @type {((inputs?: Transcript_Export_Include_SpeakersInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Transcript_Export_Include_SpeakersInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_transcript_export_include_speakers(inputs)
	if (locale === "de") return de_transcript_export_include_speakers(inputs)
	if (locale === "it") return it_transcript_export_include_speakers(inputs)
	if (locale === "ru") return ru_transcript_export_include_speakers(inputs)
	if (locale === "es") return es_transcript_export_include_speakers(inputs)
	if (locale === "zh-CN") return zh_cn2_transcript_export_include_speakers(inputs)
	if (locale === "ja") return ja_transcript_export_include_speakers(inputs)
	if (locale === "hi") return hi_transcript_export_include_speakers(inputs)
	if (locale === "pt-PT") return pt_pt2_transcript_export_include_speakers(inputs)
	return en_transcript_export_include_speakers(inputs)
});